import React, { forwardRef } from "react";
import { bool, node, oneOfType, string } from "prop-types";

import * as S from "./styled";

const CheckboxInput = forwardRef(
  ({ className, disabled, label, name, value, ...props }, ref) => (
    <S.Label className={className} disabled={disabled}>
      <S.Checkbox
        ref={ref}
        disabled={disabled}
        name={name}
        value={value}
        {...props}
      />
      {label}
    </S.Label>
  )
);

CheckboxInput.displayName = "CheckboxInput";

CheckboxInput.propTypes = {
  className: string,
  disabled: bool,
  label: oneOfType([string, node]).isRequired,
  name: string.isRequired,
  value: string.isRequired
};

CheckboxInput.defaultProps = {
  className: "",
  disabled: false
};

export default CheckboxInput;
